
import { Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { IAnswer } from '@boldpenguin/sdk';
import { AppConfig } from 'src/app/app.config';
import { AbstractGoogleMapApiService } from './abstract-google-maps.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapApiService implements AbstractGoogleMapApiService {
  private renderer: Renderer2;
  public addressAnswers: IAnswer[];
  constructor(@Inject(DOCUMENT) private document: Document, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadGoogleMapsApi(): any {
    const url =
      'https://maps.googleapis.com/maps/api/js?key=' +
      AppConfig.settings.bqxCoreConfig.GoogleMapsApiToken +
      '&libraries=geometry,places&language=en-US';
    return new Promise<void>((resolve, reject) => {
      const PreGoogleMapsApiScript = document.getElementById('agmGoogleMapsApiScript');
      if (PreGoogleMapsApiScript !== null) {
        resolve();
        return;
      }
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.id = 'agmGoogleMapsApiScript';
      script.src = url;
      script.text = '';
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer.appendChild(this.document.body, script);
    });
  }
}
